// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1y5iF","title":"Info_title__2rhtB","selects":"Info_selects__1XDZx","requiredAsterisk":"Info_requiredAsterisk__1cF6h"};